import React, { ButtonHTMLAttributes } from 'react';
import '../../base.scss';
import './Tabs.scss';
import { classNames } from '../../utilities';

export interface TabProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Tabs component injects this boolean */
  active?: boolean;
  /** The tab contents to display */
  children?: React.ReactNode;
  /** Attach a custom class to the tab container */
  className?: string;
  /** stable key for tests or 3rd party handlers */
  'data-testid'?: string;
  /** Override generated id */
  id?: string;
  /** tab identifier */
  itemKey?: string;
  /** Callback when this tab header is clicked  */
  onTabClick?: (key: string, event: React.MouseEvent<HTMLElement>) => void;
  /** text to display in the tab header */
  title: string;
}

/*
  A <Tab> is the tab in the tablist,
    as well as the children which represents the tabpanel content

  Combining both functionality that is distinct from the dom hierarchy allows:

    <Tabs ...>
      <Tab title="Tab 1" ...>Tab 1 content</Tab>
      <Tab title="Tab 2" ...>Tab 2 content</Tab>
    </Tabs
 */
export function Tab(props: TabProps) {
  const { active, children, className, id, itemKey, onTabClick, ...rest } = props;

  const tabsClassNames = classNames('ps-tabs__tab', active ? 'ps-tabs__tab--active' : '', className);

  return (
    <button
      aria-selected={active}
      className={tabsClassNames}
      id={id}
      key={itemKey}
      role="tab"
      onClick={event => onTabClick?.(itemKey || '0', event)}
      {...rest}
    >
      {children}
    </button>
  );
}
